const PLATFORM_HOSTS = new Set(['mystoragemate.com', 'www.mystoragemate.com', 'localhost', '127.0.0.1']);

/**
 * True on the product's own site. Every other host is a company's subdomain or custom domain,
 * where visitors are that company's customers rather than companies shopping for software.
 * Azure deployment previews count as the product's site.
 */
export function isPlatformHost(hostname: string = window.location.hostname): boolean {
  return PLATFORM_HOSTS.has(hostname) || hostname.endsWith('.azurewebsites.net');
}
